import React, { Fragment } from "react";
import { updateMetadata, fetchMetadatas } from "actions/metadata";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "next/router";
import CardDetailLoader from "components/CardDetailLoader";
import SlimCTA from "components/SlimCTA";
import { fetchMerchantAccountProductsPrices } from "actions/merchantAccount";
import {
  ensureMetadatas,
  ensureProductsPrices,
  useCurrentManifestLiveVariation
} from "utils/hooks";
import Padder from "components/Padder";
import MetadataBezel from "./MetadataBezel";
import { useCtxReferences } from "utils/selectors";
import { getAppPageRoutes } from "utils/application";

const PUBLISH_REQUIRED =
  "This page needs to be published before it's metadata can be updated.";

const SettingsMetadatasContainer = ({ actions }) => {
  const { application } = useCtxReferences();
  const { loading: loadingProducts } = ensureProductsPrices({
    fetchMerchantAccountProductsPrices:
      actions.fetchMerchantAccountProductsPrices
  });
  const { loading: loadingMetadatas } = ensureMetadatas({
    fetchMetadatas: actions.fetchMetadatas
  });
  const liveVariation = useCurrentManifestLiveVariation();
  const routes = getAppPageRoutes(application);

  const loading = Boolean(loadingProducts || loadingMetadatas);

  let content;
  if (loading) {
    content = <CardDetailLoader />;
  } else {
    const activeRoute = liveVariation && liveVariation.route;
    const routesWithoutActive = [...routes];
    const ctxRouteIndex = routes.findIndex((route) => route === activeRoute);
    routesWithoutActive.splice(ctxRouteIndex, 1);

    let activeRouteSection;
    if (!activeRoute) {
      activeRouteSection = <SlimCTA subheader={PUBLISH_REQUIRED} />;
    } else {
      activeRouteSection = <MetadataBezel route={liveVariation.route} />;
    }
    content = <div className="w-100 pt3">{activeRouteSection}</div>;
  }

  return (
    <div className="w-100 flex flex-column">
      {content}
      <Padder theme="visible" />{" "}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      updateMetadata,
      fetchMetadatas,
      fetchMerchantAccountProductsPrices
    },
    dispatch
  )
});

export default withRouter(
  connect(null, mapDispatchToProps)(SettingsMetadatasContainer)
);
